import React from 'react';
import GenericList from 'src/shared/genericList';
import { useTranslation } from 'react-i18next';

export default function DisplayShiftsList() {
  const { t } = useTranslation();
  const columns = [
    { field: 'display_shift_id', headerName: 'ID', hide: true },
    {
      field: 'shift_name',
      headerName: t('DISPLAY_SHIFT'),
      width: 75,
      editable: true,
      flex: 1,
    },
  ];

  return <GenericList objectName={'display_shift'} columns={columns} />;
}
